import { InlineValuePopover, PopoverList } from "@xola/ui-kit";
import React, { useState } from "react";
import { DatepickerPreference, PriceDisplay } from "types";

interface DisplayTypeFormInlinePopoverProps {
    values: DatepickerPreference;
    setFieldValue: (field: string, value: PriceDisplay) => void;
}

export const DisplayPriceInlinePopover = ({ values, setFieldValue }: DisplayTypeFormInlinePopoverProps) => {
    const [showPriceDisplayPopover, setShowPriceDisplayPopover] = useState(false);

    return (
        <InlineValuePopover
            showArrow
            text={values.priceDisplay}
            isOpen={showPriceDisplayPopover}
            classNames={{ text: "px-0.5 pb-0.5 mx-1 text-black" }}
            onClick={() => setShowPriceDisplayPopover(true)}
            onClickOutside={() => setShowPriceDisplayPopover(false)}
        >
            <PopoverList.Item
                name={PriceDisplay.LOWEST}
                onClickItem={() => setFieldValue("priceDisplay", PriceDisplay.LOWEST)}
            >
                {PriceDisplay.LOWEST}
            </PopoverList.Item>

            <PopoverList.Item
                name={PriceDisplay.HIGHEST}
                onClickItem={() => setFieldValue("priceDisplay", PriceDisplay.HIGHEST)}
            >
                {PriceDisplay.HIGHEST}
            </PopoverList.Item>
        </InlineValuePopover>
    );
};
